export default {
  words: [],
  wordsLoading: {},
};
